/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  eventService,
  commissionService,
  commissionsService,
  actionService
) => {
  $scope.Model = {
    availableCommissions: [],
    commissionsList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  const loadCommissions = () => {
    webpage.pageTitle('Loading, please wait');
    commissionsService
      .getAvailable({ isActive: !$scope.Model.isArchive })
      .then((data) => {
        // Set Model values
        $scope.Model.availableCommissions = data;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Commission groups : Settings');
        $scope.Model.isReady = true;
      });
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    loadCommissions();
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('commissionDelete', () => {
    commissionsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.commissionsList.getSelected(),
      commissionService.deleteCommission,
      $scope.Model.commissionsList.removeData,
      'commission(s)'
    );
  });
  $scope.$on('commissionDuplicate', () => {
    commissionsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.commissionsList.getSelected(),
      commissionService.readCommission,
      commissionService.createCommission,
      $scope.Model.commissionsList.setDataAppend,
      'name',
      ' copy',
      'commission(s)'
    );
  });
  $scope.$on('commissionActivate', () => {
    commissionsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.commissionsList.getSelected(),
      commissionService.updateCommission,
      $scope.Model.commissionsList.removeData,
      'commission(s)',
      true
    );
  });
  $scope.$on('commissionArchive', () => {
    commissionsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.commissionsList.getSelected(),
      commissionService.updateCommission,
      $scope.Model.commissionsList.removeData,
      'commission(s)',
      false
    );
  });
  $scope.$on('commissionAdd', (e, $event) => {
    commissionsService.clearCache();
    eventService.commissionEdit({
      event: $event,
      commission: null,
      list: $scope.Model.commissionsList
    });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.commissionEdit = ($event, commission) => {
    eventService.commissionEdit({
      event: $event,
      commission,
      list: $scope.Model.commissionsList
    });
  };

  $scope.commissionEdited = (commissionToEdit) => {
    const commission = commissionToEdit;
    commissionsService.clearCache();
    if (commission.isNew === true) {
      delete commission.isNew;
      if (commission.isActive !== $scope.Model.isArchive) {
        $scope.Model.commissionsList.setDataAppend(commission);
      }
    } else {
      $scope.Model.commissionsList.setDataReplace(commission);
    }
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.commissionsList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadCommissions();
        }
      }
    );
  };
};
